import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { dealerBlocked } from "./api-interfaces/dealerBlockedServices.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIDealerBlockedServices {
    ApiURL: string = "";

    constructor(private http: HttpClient, public helperService: HelperService) {
        this.ApiURL = environment.dealerBlockerURL + 'WorkshopBlockedServices/';

        // https://devbooking.inchcape.digital/api/BookingSystem.ApiWorkshopBlockedServices/api/WorkshopBlockedServices/BlockedServicesByBrandWorkshop/3
    }

    public getByTypeOfServiceDateTime(typeOfService: number, date: string, initialHour): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get(this.ApiURL + encodeURIComponent(typeOfService)+'/'+date+'/'+initialHour, requestOptions);
    }

    public getbyworkshopId(workshopId: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get(this.ApiURL + 'byDealer/'+ encodeURIComponent(workshopId), requestOptions);
    }

    public get(serviceId: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        if (serviceId!== null && serviceId!== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(serviceId), requestOptions);
        } else {
            return this.http.get(this.ApiURL, requestOptions);
        }
    }

    public getbyworkshopandbrandId(workshopId: number,brandId?:number): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        if (brandId!== null && brandId!== undefined) {
            return this.http.get(this.ApiURL + 'BlockedServicesByBrandWorkshop/'+encodeURIComponent(workshopId) +"/"+encodeURIComponent(brandId), requestOptions);
        } else {
            return this.http.get(this.ApiURL + 'BlockedServicesByBrandWorkshop/'+encodeURIComponent(workshopId), requestOptions);
        }
    }

    public  getworkshopHistorialLocks(workshopId: number): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.get(this.ApiURL + 'getworkshopBlocked/'+encodeURIComponent(workshopId), requestOptions);
    }

    public post(dataint:dealerBlocked): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.post<any>(this.ApiURL, dataint, requestOptions)
    }

    public put(dataint:dealerBlocked): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.put<any>(this.ApiURL,dataint, requestOptions)
    }

    public delete({id}, {day}, {hourini}):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        let apiURL = `${this.ApiURL}${id}/${day}/${hourini}`;
        return this.http.delete(apiURL, requestOptions)
    }

    public deleteIdlocksettings(id):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.delete(this.ApiURL+id, requestOptions)
    }
    public deletClusterlocksettings(workshopid,initialdate,finaldate,initialhour,finalhour):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.delete(this.ApiURL+'DeleteWorkshopBlockedService/'+`${workshopid}/${initialdate}/${finaldate}/${initialhour}/${finalhour}`, requestOptions)
    }
}
